
const namespace = 'navigation/';
export const GOTO_ORDERS = `${namespace}/GOTO_ORDERS`;

export function gotoOrderList() {
  return {
    type: GOTO_ORDERS
  }
}

export default gotoOrderList;


// WEBPACK FOOTER //
// ./src/actions/NavigationActions.js